"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiRadio = void 0;
var colors_1 = require("../../generated/colors");
exports.MuiRadio = {
    styleOverrides: {
        root: {
            padding: "0 8px 0 0",
            "&.Mui-disabled": {
                color: colors_1.colors.Grey4,
            },
        },
    },
};
//# sourceMappingURL=radio.js.map